import React, { FC, useContext } from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { Col } from 'layout';
import NewsGridImage from 'common/NewsGrid/NewsGridImage';
import NewsGridTags from 'common/NewsGrid/NewsGridTags';

import ScreenRecognitionContext from '../../../contexts/screenRecognitionContext';
import NewsListInformationWithTags from '../NewsListInformationWithTags';
import { NewsListArticleProps } from './models';

import './NewsListArticle.scss';

const NewsListArticle: FC<NewsListArticleProps> = ({ article, lang, readingTimeText }) => {
  const { isMobile, isSmallMobile, isTablet, isDesktop, isLargeDesktop } =
    useContext(ScreenRecognitionContext);

  return (
    <Col xl="12" className="col--no-gutters">
      <div className="article">
        <Link to={article.url} className="article__title-link" test-id="article-link">
          <span className="sr-only">{article.title}</span>
        </Link>
        <div
          className={classNames('article__title-container', {
            'article__title-container--without-image': !article.previewImage,
          })}
        >
          <h2 className="article__title h6">{article.title}</h2>
          <p className="article__description caption">{article.previewText}</p>
        </div>
        <NewsListInformationWithTags
          tagName={article.articleType?.tagName}
          creationDate={article.creationDate}
          articleTypeColor={article.articleType?.color}
          readingTime={article.readingTime}
          readingTimeText={readingTimeText}
          articleTags={article.articleTags}
          lang={lang}
        />
        {!isTablet && !isDesktop && !isLargeDesktop ? (
          <NewsGridTags article={article.articleTags} />
        ) : null}
        {!isMobile && !isSmallMobile ? (
          <div className="article__img-container">
            <NewsGridImage article={article.previewImage} />
          </div>
        ) : null}
      </div>
    </Col>
  );
};

export default NewsListArticle;
